<template>
    <!-- 背景图跟首页同一个来源：站点设置里「图片配置」那张背景图（setting.page） -->
    <div class="box_back" :style="bgStyle">
        <div class="forContainer">

                    <h3>网页管理后台</h3>
                    <el-form ref="loginFormRef" :model="loginForm" status-icon :rules="loginRules" label-width="80px"
                        class="loginform" @submit.prevent="submitForm" @keyup.enter="submitForm">
                        <!-- 账户 / 密码：各只有一个输入框。autocomplete 明确写成
                             username / current-password，避免浏览器密码管理器在页面上
                             再叠一层自动填充控件（那样看起来就像多了一个输入框）。
                             name 也补上，省得浏览器认不出这是登录表单。 -->
                        <el-form-item label="账户" prop="username">
                            <el-input v-model="loginForm.username" name="username" autocomplete="username"
                                :disabled="loading" />
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input v-model="loginForm.password" name="password" type="password"
                                autocomplete="current-password" show-password :disabled="loading"
                                @keyup.enter="submitForm" />
                        </el-form-item>

                        <div
                            style="display: flex; flex-direction: column; align-items: center; margin-left: -15%; margin-top: -0%;">
                            <el-form-item>
                                <el-button type="primary" :loading="loading" @click="submitForm()">登录</el-button>
                            </el-form-item>
                        </div>

                    </el-form>
        </div>

        <!-- 登录中遮罩：转圈 + 期间点不动、也不重复提交 -->
        <teleport to="body">
            <div v-if="loading" class="login-mask" @click.stop.prevent @mousedown.stop.prevent @contextmenu.prevent>
                <div class="login-mask-card">
                    <div class="login-spinner"></div>
                    <p class="login-mask-title">正在登录…</p>
                    <p class="login-mask-tip">正在校验账号密码，请稍候</p>
                </div>
            </div>
        </teleport>

        <!-- 备案号照旧注释掉
        <div style="margin-top: 90%; color: aliceblue; position: fixed; bottom: 0; left: 0; right: 0; text-align: center;">
            <a href="https://beian.miit.gov.cn/" target="_blank" style="color: aliceblue;font-size: 10px;">ICP备案号  ————  </a>
        </div>
        -->
    </div>
</template>

<script setup>
import { Button } from 'element-plus';
import { computed, onMounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex';
import { ASSET_BASE } from '../util/assetBase';

// import 'element-plus/lib/theme-chalk/index.css';

const store = useStore()
const loginForm = reactive({
    username: "",
    password: "",
})//表单绑定的响应对象

const loginFormRef = ref() //表单的引用对象

// 登录请求进行中：按钮转圈、输入框锁掉、整页盖一层遮罩
const loading = ref(false)

//校验规则
const loginRules = reactive({
    username: [{ required: true, message: "请输入用户名", trigger: 'blur' }],
    password: [{ required: true, message: "请输入密码", trigger: 'blur' }],
})

const router = useRouter();

/* ---------------- 背景图：跟首页用同一张 ----------------
 * 首页（views/UserPage/home.vue）是 setting.page 拼 ASSET_BASE；
 * 这里照抄同一套，拉到之前先用 CSS 里那张 back1.jpg 顶着，不会白屏。 */
const DEFAULT_BACKGROUND = 'https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg';
const backgroundImageUrl = ref('');

const bgStyle = computed(() => (backgroundImageUrl.value ? { backgroundImage: 'url(' + backgroundImageUrl.value + ')' } : {}));

onMounted(async () => {
    try {
        // setting/list 是前台公开接口，登录前也能读；带时间戳绕开缓存
        const res = await axios.get('/adminapi/setting/list?_=' + Date.now());
        const s = (res.data && res.data.results && res.data.results[0]) || {};
        backgroundImageUrl.value = s.page ? ASSET_BASE + s.page : DEFAULT_BACKGROUND;
    } catch (e) {
        backgroundImageUrl.value = DEFAULT_BACKGROUND;
    }
});

const submitForm = () => {
    if (loading.value) return // 登录中按回车/点按钮都忽略，不发第二次请求

    loginFormRef.value.validate(async (valid) => {
        if (!valid) return

        loading.value = true
        try {
            const res = await axios.post("/adminapi/admin/login", loginForm)
            const data = res.data || {}
            if (data.ActionType === 'OK') {
                // 换账号登录时先清掉上一个身份的缓存，避免旧 role 影响路由准入判断
                store.commit("clearUserInfo")
                store.commit("changeUserInfo", data.data)
                store.commit("changeGetterRouter", false)
                loginForm.password = ''
                await router.push("/admin/index")
            } else {
                ElMessage.error(data.message || '账号或密码错误')
            }
        } catch (error) {
            const msg = error?.response?.data?.message
            ElMessage.error(msg || '登录失败，请检查网络后重试')
        } finally {
            loading.value = false
        }
    })
}

</script>

<style lang="scss" scoped>
.box_back {
    width: 100%;
    height: 100%;
    background-image: url(../image/back1.jpg);
    background-size: cover;
    background-position: top left;
    background-repeat: no-repeat;
    position: fixed;
}

.forContainer {
    width: 500px;
    height: 280px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.7);
    text-align: center;
    color: rgb(255, 255, 255);
    padding: 20px;
    border-radius: 10px;

    h3 {
        margin-top: 20px;
        font-size: 30px;
    }

    .loginform {
        margin-top: 40px;
    }
}

/* 手机端：登录框原来是死宽 500 + 40 内边距 = 540，390 屏上左右各被切掉 75px，
   输入框都露不全。这里改成按屏宽自适应。 */
@media (max-width: 768px) {
    .box_back {
        background-position: top center;
    }

    .forContainer {
        width: 92vw;
        max-width: 420px;
        height: auto;
        padding: 18px 14px 22px;
        box-sizing: border-box;

        h3 {
            margin-top: 8px;
            font-size: 22px;
        }

        .loginform {
            margin-top: 24px;
            padding-right: 8px;

            :deep(.el-form-item__label) {
                font-size: 14px;
            }
        }
    }

    /* 登录按钮原来靠负 margin 硬拽，手机上会跑偏，这里改成正常居中 */
    .forContainer .loginform > div {
        margin-left: 0 !important;
        margin-top: 6px !important;
    }
}
</style>

<style>
/* 遮罩用 teleport 挂到 body 上，所以样式不能带 scoped */
.login-mask {
    position: fixed;
    inset: 0;
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, .45);
    cursor: wait;
    user-select: none;
}

.login-mask-card {
    width: 260px;
    padding: 26px 24px 18px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 12px 32px rgba(0, 0, 0, .18);
    text-align: center;
}

.login-mask-title {
    margin: 0;
    font-size: 15px;
    font-weight: 500;
    color: #303133;
}

.login-mask-tip {
    margin: 8px 0 0;
    font-size: 12px;
    color: #909399;
}

.login-spinner {
    width: 46px;
    height: 46px;
    margin: 0 auto 16px;
    border: 4px solid #e4e7ed;
    border-top-color: #409eff;
    border-radius: 50%;
    animation: login-spin .8s linear infinite;
}

@keyframes login-spin {
    to { transform: rotate(360deg); }
}
</style>
